<template lang="html">
  <div class="interface-footer"></div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.interface-footer {
  height: 10px;
  border-radius: 0 0 5px 5px;
  background-color: white;
}
</style>
